import { getOrderStatusConfig } from "@/constants/status";
import type { OrderStatus, PickupMethod } from "@/types";

interface StatusBadgeProps {
  status: OrderStatus;
  pickup?: PickupMethod;
  showDot?: boolean;
}

export default function StatusBadge({
  status,
  pickup,
  showDot = true,
}: StatusBadgeProps) {
  const config = getOrderStatusConfig(status, pickup);
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${config.className}`}
    >
      {showDot && (
        <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`}></span>
      )}
      {config.label}
    </span>
  );
}